export default __webpack_public_path__ + "static/media/resource-sauna-featured-image-placeholder.dc7adc06.svg";